import { render, staticRenderFns } from "./ExchangeSet.vue?vue&type=template&id=7b000578&"
import script from "./ExchangeSet.vue?vue&type=script&lang=js&"
export * from "./ExchangeSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports